<template>
    <div class="layout-mobile-header-container" :class="{'header-mobile-header-container':type}">
        <router-link to="/" class="layout-mobile-header-container__logo" tag="div"  >
            <img src="../../assets/img/index/new-logo-header.png" alt="" v-if="!type">
        </router-link>
        <div class="layout-mobile-header-container__action" >
            <a-icon @click="handleSearch" type="search" />
            <a-icon @click="changeShowSidebar(!showSidebar)" type="menu" />
        </div>
        <van-popup :value="showSidebar" @click-overlay="changeShowSidebar(false)" position="left"
                   class="layout-mobile-slide-menu">
            <layout-sidebar-user />
            <layout-sidebar-menu />
        </van-popup>
    </div>
</template>

<script>
    import LayoutSidebarUser from "@components/layout/sidebar/LayoutSidebarUser";
    import LayoutSidebarMenu from "@components/layout/sidebar/LayoutSidebarMenu";
    import {SEARCH_PATH} from "@constants/router-path";
    import common from "../../mixin/common";

    export default {
        name: "LayoutMobileHeader",
        mixins: [common],
        components: {LayoutSidebarUser, LayoutSidebarMenu},
        methods: {
            handleSearch() {
                this.$router.push(SEARCH_PATH)
            },
        },
        props:{
          type:{
            type:Boolean,
            default:false,
          }
        },
    }

</script>

<style scoped lang="less">

    .layout-mobile-header-container {
        display: flex;
        justify-content: space-between;
        height: 50px;
        width: 100%;
        padding: 5px;
        background: white;


        &__logo {
          padding:0 5px;
          line-height: 40px;
            img {
                height: 80%;
            }
        }

        &__action {
            line-height: 40px;
            font-size: 18px;
            color: rgba(0, 0, 0, 0.45);

            i {
                margin-right: 10px;
            }
        }
    }
    .header-mobile-header-container{
      background-color:transparent;
      margin-top: -30px;
      .layout-mobile-header-container__action{
        color: #fff;
        margin-right: -28px;
      }
    }
    // 右侧边栏
    .layout-mobile-slide-menu {
        width: 180px;
        height: 100%;
        background: white;

        .login-container {
            padding: 0;
            margin: 0;
        }
    }
</style>
